import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LockIcon, AlertCircleIcon } from 'lucide-react';
export const AccountLockedPage = () => {
  const {
    lockoutUntil
  } = useAuth();
  const formatTimeRemaining = (lockoutTime: Date) => {
    const now = new Date();
    const diff = lockoutTime.getTime() - now.getTime();
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor(diff % 60000 / 1000);
    return `${minutes}m ${seconds}s`;
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-3433">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3434">
        <div className="flex justify-center" data-id="element-3435">
          <div className="h-12 w-12 bg-red-100 rounded-full flex items-center justify-center" data-id="element-3436">
            <LockIcon className="h-8 w-8 text-red-600" data-id="element-3437" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-3438">
          Account Temporarily Locked
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-3439">
          For your security, your account has been temporarily locked due to
          multiple failed login attempts.
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3440">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-3441">
          <div className="rounded-md bg-red-50 p-4" data-id="element-3442">
            <div className="flex" data-id="element-3443">
              <div className="flex-shrink-0" data-id="element-3444">
                <AlertCircleIcon className="h-5 w-5 text-red-400" data-id="element-3445" />
              </div>
              <div className="ml-3" data-id="element-3446">
                <h3 className="text-sm font-medium text-red-800" data-id="element-3447">
                  Account Locked
                </h3>
                <div className="mt-2 text-sm text-red-700" data-id="element-3448">
                  <p data-id="element-3449">
                    Please wait{' '}
                    {lockoutUntil && formatTimeRemaining(lockoutUntil)} before
                    trying again.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6" data-id="element-3450">
            <div className="relative" data-id="element-3451">
              <div className="relative flex justify-center text-sm" data-id="element-3452">
                <span className="px-2 bg-white text-gray-500" data-id="element-3453">Need help?</span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-3" data-id="element-3454">
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-3455">
                Contact Support
              </a>
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-3456">
                Reset Password
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};